import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import {FormsModule} from '@angular/forms';
import {AngularMaterialModule} from '../app-module/angular-matrial.module';
import {LoginProvider} from './loginProvider';
import {SignUpDialogModule} from '../signup-dialog/signup-dialog.module';
import {SignUpDialogComponent} from '../signup-dialog/signup-dialog.component';
import {SignUpProvider} from '../signup-dialog/signup-provider';


@NgModule({
    imports: [CommonModule, 
    LoginRoutingModule,
    FormsModule,
    AngularMaterialModule,SignUpDialogModule
        ],
    declarations: [LoginComponent],
    providers:[LoginProvider,SignUpProvider],
//    entryComponents: [SignUpDialogComponent]
})
export class LoginModule {}
